/**
 * SIDC MMS Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManualApplicantDataEncodingDTO { 
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffixName?: string;
    emailAddress?: string;
    contactNumber?: string;
    birthday?: string;
    age?: number;
    religion?: string;
    educationalAttainment?: string;
    numberOfDependents?: number;
    spouseName?: string;
    spouseOccupation?: string;
    dateOfMarriage?: string;
    fatherName?: string;
    fatherOccupation?: string;
    motherMaidenName?: string;
    motherOccupation?: string;
    telephoneNumber?: string;
    street?: string;
    barangay?: string;
    city?: string;
    province?: string;
    zipCode?: string;
    civilStatus?: string;
    isSidcEmployee?: boolean;
    representativeOf?: string;
    remarks?: string;
    generatedBy?: string;
    dateOfMedical?: string;
    actualPmesDate?: string;
    genderId?: number;
    applicationStatusId?: number;
    regionId?: number;
}